import React, { useState } from "react";
import { Container, Row, Col, Form, Button, InputGroup } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { validatePassword, getPasswordRequirements } from "../utils/passwordValidation";

const InitialSetup: React.FC = () => {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useI18n();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    // Validate password
    const passwordErrors = validatePassword(password, t);
    if (passwordErrors.length > 0) {
      toast.error(passwordErrors.join(". "));
      return;
    }
    
    setLoading(true);
    try {
      const resp = await axios.post("/api/auth/initial-setup", {
        username,
        email,
        password,
      });
      if (resp.status === 201) {
        toast.success(t("messages.adminCreated"));
        navigate("/login");
      }
    } catch (err: any) {
      const msg = err?.response?.data?.detail || "Failed to create admin";
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={6}>
          <h3>{t("initialSetup.title")}</h3>
          <p>{t("initialSetup.subtitle")}</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-2">
              <Form.Label>{t("common.username")}</Form.Label>
              <Form.Control
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>{t("common.email")}</Form.Label>
              <Form.Control
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>{t("common.password")}</Form.Label>
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i className={showPassword ? "bi bi-eye-slash" : "bi bi-eye"}></i>
                </Button>
              </InputGroup>
              <Form.Text className="text-muted">
                {getPasswordRequirements(t)}
              </Form.Text>
            </Form.Group>
            <div className="d-flex justify-content-end">
              <Button variant="primary" type="submit" disabled={loading}>
                {loading ? t("initialSetup.creating") : t("initialSetup.createButton")}
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default InitialSetup;
